import { useState } from "react";
import "./AdminLogin.css";

const Icon = ({ d, size = 16, strokeWidth = 1.75, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        {Array.isArray(d) ? d.map((path, i) => <path key={i} d={path} />) : <path d={d} />}
    </svg>
);

const icons = {
    email: ['M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z', 'm22 6-10 7L2 6'],
    lock: ['rect width="18" height="11" x="3" y="11" rx="2" ry="2"', 'path d="M7 11V7a5 5 0 0 1 10 0v4"'],
};

export default function AdminLogin({ onLogin }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        try {
            const res = await fetch("/api/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            const data = await res.json();

            if (res.ok) {
                if (data.user.userType !== 'admin') {
                    setError("Not authorized. This portal is for Superadmins only.");
                    setIsLoading(false);
                    return;
                }
                localStorage.setItem("ops-user", JSON.stringify(data.user));
                onLogin(data.user);
            } else {
                setError(data.message || "Invalid credentials. Please try again.");
            }
        } catch (err) {
            setError("Connection failed. Check your server.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-side-decoration admin-theme">
                <div className="glass-logo">
                    <div className="logo-symbol">S</div>
                    <span className="logo-text">Superadmin</span>
                </div>
                <div className="decor-content">
                    <h2>Opsmaticz Control</h2>
                    <p>Manage operators, plans, and global system configurations.</p>
                </div>
                <div className="animated-blobs">
                    <div className="blob blob-1"></div>
                    <div className="blob blob-2"></div>
                    <div className="blob blob-3"></div>
                </div>
            </div>

            <div className="login-main">
                <div className="login-box">
                    <div className="login-box-header">
                        <h1>Superadmin Login</h1>
                        <p>Sign in to your administration dashboard</p>
                    </div>

                    <form className="login-form-premium" onSubmit={handleSubmit}>
                        {error && (
                            <div className="error-message-shake">
                                <Icon d={['M12 8v4', 'M12 16h.01', 'M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z']} size={18} />
                                <span>{error}</span>
                            </div>
                        )}

                        <div className="input-field">
                            <label>Admin Email</label>
                            <div className="input-inner">
                                <Icon d={icons.email} size={18} className="input-icon-svg" />
                                <input
                                    type="email"
                                    placeholder="admin@opsmaticz.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="input-field">
                            <div className="label-row">
                                <label>Password</label>
                            </div>
                            <div className="input-inner">
                                <Icon d={['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z']} size={18} className="input-icon-svg" />
                                <input
                                    type="password"
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <button type="submit" className="submit-btn" disabled={isLoading}>
                            {isLoading ? (
                                <span className="loader-text">
                                    <span className="dot-flashing"></span>
                                    Verifying...
                                </span>
                            ) : (
                                <>
                                    <span>Enter Admin Panel</span>
                                    <Icon d={['M5 12h14', 'm12 5 7 7-7 7']} size={18} strokeWidth={2} />
                                </>
                            )}
                        </button>
                    </form>
                </div>
                <div className="login-box-footer" style={{ marginTop: '20px', textAlign: 'center' }}>
                    <p><a href="#operator-login" className="forgot-link" style={{ color: '#f59e0b', fontWeight: 600 }}>← Back to Operator Login</a></p>
                </div>
            </div>
        </div>
    );
}
